import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

/**
 * PropertySearchPage component
 * Property search and viewing for prospective tenants
 */
const PropertySearchPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="property-search-container">
      <div className="property-search-content">
        <div className="property-search-header">
          <button className="back-button" onClick={() => navigate(ROUTES.HOME)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="19" y1="12" x2="5" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <polyline points="12,19 5,12 12,5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Back
          </button>
          <h1 className="property-search-title">Available Properties</h1>
          <p className="property-search-subtitle">Explore our rental listings</p>
        </div>

        <div className="property-search-body">
          <div className="coming-soon-card">
            <div className="coming-soon-icon">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 className="coming-soon-title">Property Listings Coming Soon!</h2>
            <p className="coming-soon-description">
              We're working on bringing our property listings online. In the meantime, please contact us directly to learn about available rentals.
            </p>
            <div className="coming-soon-features">
              <div className="feature-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="20,6 9,17 4,12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Virtual tours
              </div>
              <div className="feature-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="20,6 9,17 4,12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Detailed listings
              </div>
              <div className="feature-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="20,6 9,17 4,12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Online applications
              </div>
              <div className="feature-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="20,6 9,17 4,12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Instant scheduling
              </div>
            </div>
          </div>

          <div className="contact-section">
            <div className="contact-card">
              <h3 className="contact-title">Contact Us</h3>
              <p className="contact-description">
                Ready to find your next home? Get in touch with us today to learn about our available properties.
              </p>
              <div className="contact-methods">
                <a href="tel:555-555-5555" className="contact-method primary">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 16.92V19.92C22 20.4728 21.5523 20.92 21 20.92H18C8.05888 20.92 0 12.8611 0 2.92V1.92C0 1.36772 0.447715 0.92 1 0.92H4C4.55228 0.92 5 1.36772 5 1.92V5.92L3 7.92C3.55228 9.92 5.86772 12.92 7.86772 13.92L10 11.92H14L15.1323 13.92C17.1323 12.92 19.4477 9.92 20 7.92L18 5.92V1.92C18 1.36772 18.4477 0.92 19 0.92H22C22.5523 0.92 23 1.36772 23 1.92V4.92" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Call Us: 555-555-5555
                </a>
                <a href="mailto:info@ramirezrentals.com" className="contact-method secondary">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M3 7L12 13L21 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Email Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertySearchPage;
